exports.version = "2.4.5"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 719
// module chunks = 0